var irreducible = require('./irreducible');
var isString = require('./isString');

module.exports = irreducible('String', isString);



//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb/lib/String.js
// module id = 113
// module chunks = 0